import { render, staticRenderFns } from "./ProfessionalApplicationReviewStatus.vue?vue&type=template&id=12b4c0cf&"
import script from "./ProfessionalApplicationReviewStatus.vue?vue&type=script&lang=js&"
export * from "./ProfessionalApplicationReviewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports